if (!customElements.get('intro-video')) {
  class IntroVideo extends HTMLElement {
    constructor() {
      super();

      this.init();
    }

    init() {
      this.video = this.querySelector('video');

      document.body.style.overflow = 'hidden';

      document.addEventListener(
        'keydown',
        (e) => {
          const isEscape = e.key === 'Escape';

          if (!isEscape) return;

          this.video.pause();
          this.close();
        },
        { once: true },
      );

      this.video.addEventListener('ended', (e) => {
        this.close();
      });
    }

    close() {
      this.classList.add('completed');
      document.body.style.overflow = '';
    }
  }

  customElements.define('intro-video', IntroVideo);
}
